"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPlaceBidDto = instanceOfPlaceBidDto;
exports.PlaceBidDtoFromJSON = PlaceBidDtoFromJSON;
exports.PlaceBidDtoFromJSONTyped = PlaceBidDtoFromJSONTyped;
exports.PlaceBidDtoToJSON = PlaceBidDtoToJSON;
exports.PlaceBidDtoToJSONTyped = PlaceBidDtoToJSONTyped;
/**
 * Check if a given object implements the PlaceBidDto interface.
 */
function instanceOfPlaceBidDto(value) {
    if (!('bidAmount' in value) || value['bidAmount'] === undefined)
        return false;
    return true;
}
function PlaceBidDtoFromJSON(json) {
    return PlaceBidDtoFromJSONTyped(json, false);
}
function PlaceBidDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'bidAmount': json['bidAmount'],
    };
}
function PlaceBidDtoToJSON(json) {
    return PlaceBidDtoToJSONTyped(json, false);
}
function PlaceBidDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'bidAmount': value['bidAmount'],
    };
}
